<script>
  import ListItem from "../components/ListItem.svelte";
  import ViewCardContainer from "../components/ViewCardContainer.svelte";
  import { t } from "../i18n.js";
  import { onMount } from "svelte";
  import { readable } from "svelte/store";

  onMount(() => {
    window.scrollTo(0, 0);
  });

  const listItems = [
    {
      id: 1,
      name: "datasource.use-case1-name",
      description: "datasource.use-case1-description",
      limitedAvailability: false,
    },
    {
      id: 2,
      name: "datasource.use-case2-name",
      description: "datasource.use-case2-description",
      limitedAvailability: false,
    },
    {
      id: 3,
      name: "datasource.use-case3-name",
      description: "datasource.use-case3-description",
      limitedAvailability: false,
    },
    {
      id: 5,
      name: "datasource.use-case5-name",
      description: "datasource.use-case5-description",
      limitedAvailability: false,
    },
    {
      id: 7,
      name: "datasource.use-case7-name",
      description: "datasource.use-case7-description",
      limitedAvailability: false,
    },
    {
      id: 8,
      name: "datasource.use-case8-name",
      description: "datasource.use-case8-description",
      limitedAvailability: false,
    },
    {
      id: 9,
      name: "datasource.use-case9-name",
      description: "datasource.use-case9-description",
      limitedAvailability: false,
    },
    {
      id: 12,
      name: "datasource.use-case12-name",
      description: "datasource.use-case12-description",
      limitedAvailability: false,
    },
  ];
</script>

<ViewCardContainer pageTitle={$t("datalist.page-title")}>
  <h2 class="mb-2">{$t("datalist.page-subtitle")}</h2>
  <p class="mb-8">{@html $t("datalist.page-description")}</p>
  {#each listItems as item}
    <div class="mb-4">
      <ListItem
        name={$t(item.name)}
        description={$t(item.description)}
        limitedAvailability={item.limitedAvailability}
        id={item.id}
      />
    </div>
  {/each}
</ViewCardContainer>
